import {
  GET_HIERARCHY,
  DELETE_RELATIONSHIP,
  ADD_RELATIONSHIP,
  DELETE_NODE,
  CREATE_NODE,
  GET_BARCODES_FOR_NODE,
  UPDATE_BARCODES_FOR_NODE,
  GET_NODE,
  GET_USERS_FOR_NODE,
  UPDATE_USERS_FOR_NODE,
  GET_SELLING_DAYS_FOR_NODE,
  UPDATE_SELLING_DAYS_FOR_NODE,
  CLEAR_SELLING_DAYS_FOR_NODE,
  GET_FEATURE_FLAGS,
  UPDATE_FEATURE_FLAGS,
  SET_OBJECTIVES_FOR_NODE,
  CLEAR_OBJECTIVES_FOR_NODE,
  GET_OBJECTIVES_FOR_NODE, SET_HEIRARCHY_EXPANSION
} from "../constants/action-types";
import Axios from "axios";

import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
const API_CONFIG = getApiConfig();


/*
    Get Hierarchy
*/
export const getHierarchy = callback => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_HIERARCHY,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
    Create New Node
*/
export const createNode = (node, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node`, {
    method: "post",
    data: node
  }).then(res => {
    dispatch({
      type: CREATE_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
    Delete Node and optionally all children
*/
export const deleteNode = (nodeId, deleteChildren, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node?id=${nodeId}&deleteDescendants=${deleteChildren}`, {
    method: "delete"
  }).then(res => {
    dispatch({
      type: DELETE_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
    Add Relationship
*/
export const addRelationship = (sourceNodeId, nodeIds, sourceIsParent, callback) => dispatch => {

  const body = sourceIsParent ?
    {
      SourceNodeId: sourceNodeId,
      ChildNodeId: nodeIds
    } :
    {
      SourceNodeId: sourceNodeId,
      ParentNodeId: nodeIds
    }

  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/relationship`, {
    method: "post",
    data: body
  }).then(res => {
    dispatch({
      type: ADD_RELATIONSHIP,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};


/*
    Delete Relationship
*/
export const deleteRelationship = (sourceNodeId, nodeIds, callback) => dispatch => {

  const body = {
    SourceNodeId: sourceNodeId,
    RelationIds: nodeIds
  }

  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/relationship/delete`, {
    method: "post",
    data: body
  }).then(res => {
    dispatch({
      type: DELETE_RELATIONSHIP,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
};

/*
    Get node
*/
export const getNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node?id=${nodeId}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
    Get Barcodes for given Node
*/
export const getBarcodesForNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/barcode?nodeId=${nodeId}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_BARCODES_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
    Update Barcodes for given Node
*/
export const updateBarcodesForNode = (nodeId, barcodes, callback) => dispatch => {
  const body = [{
    "NodeId": nodeId,
    "Barcodes": barcodes
  }]
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/barcode`, {
    method: "post",
    data: body
  }).then(res => {
    dispatch({
      type: UPDATE_BARCODES_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
    Get Users for given Node
*/
export const getUsersForNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/users/${nodeId}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_USERS_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
    Update Users for given Node
*/
export const updateUsersForNode = (nodeId, users, callback) => dispatch => {
  const body = [{
    "NodeId": nodeId,
    "Users": users
  }]
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/users`, {
    method: "post",
    data: body
  }).then(res => {
    dispatch({
      type: UPDATE_USERS_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}


/*
    Get Selling Days for given Node
*/
export const getSellingWeeksForNode = (nodeId, callback) => dispatch => {

  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/selling-days?nodeId=${nodeId}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_SELLING_DAYS_FOR_NODE,
      payload: {
        nodeId: nodeId,
        sellingWeeks: res.data
      }
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
    Update Selling Days for given Node
*/
export const updateSellingWeeksForNode = (nodeId, sellingWeeksCSV, callback) => dispatch => {
  const formData = new FormData();
  formData.append('file', sellingWeeksCSV)


  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/selling-days?nodeId=${nodeId}`, {
    method: "post",
    header: {
      'Content-Type': 'multipart/form-data'
    },
    data: formData
  }).then(res => {
    dispatch({
      type: UPDATE_SELLING_DAYS_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
    Update Selling Days for given Node
*/
export const clearSellingWeeksForNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/selling-days?nodeId=${nodeId}`, {
    method: "delete"
  }).then(res => {
    dispatch({
      type: CLEAR_SELLING_DAYS_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/* 
    Get all Feature Flags
*/
export const getFeatureFlagsForNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/featureflag/${nodeId}`, {
    method: "get"
  })
    .then(res => {
      dispatch({
        type: GET_FEATURE_FLAGS,
        payload: res.data
      });
      callback(true);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error.message}`);
      callback(false);
    })
};

/* 
  Update Feature Flags
*/
export const updateFeatureFlagsForNode = (nodeId, featureFlagsJSON, callback) => dispatch => {
  var featureFlags
  try {
    featureFlags = JSON.parse(featureFlagsJSON)
  } catch (error) {
    console.log(`Exception Occurred: ${error.message}`);
    callback(false, error)
    return
  }

  const data = {
    NodeId: nodeId,
    Flags: featureFlags
  }

  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/featureflag`, {
    method: "post",
    data: data
  })
    .then(res => {
      dispatch({
        type: UPDATE_FEATURE_FLAGS,
        payload: res.data
      });

      callback(true, null);
    }).catch((error) => {
      console.log(`Exception Occurred: ${error.message}`);
      callback(false, error);
    })
};

/*
  Get objectives for the current node
*/
export const getObjectivesForNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/objective/${nodeId}`, {
    method: "get"
  }).then(res => {
    dispatch({
      type: GET_OBJECTIVES_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
  Set objectives for the current node
*/
export const setObjectivesForNode = (nodeId, objectiveIds, callback) => dispatch => {
  const data = {
    NodeId: nodeId,
    Objectives: objectiveIds
  }

  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/objective`, {
    method: "post",
    data: data
  }).then(res => {
    dispatch({
      type: SET_OBJECTIVES_FOR_NODE,
      payload: res.data
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
  Clear all objectives for the current node
*/
export const clearObjectivesForNode = (nodeId, callback) => dispatch => {
  adalApiFetch(Axios, `${API_CONFIG.URL}/hierarchy/node/objective/${nodeId}`, {
    method: "delete"
  }).then(res => {
    dispatch({
      type: CLEAR_OBJECTIVES_FOR_NODE,
      payload: null
    });

    callback(true);
  }).catch((error) => {
    console.log(`Exception Occurred: ${error}`);
    callback(false);
  });
}

/*
  Sets heirarchy tree expansion
*/
export const setHeirarchyExpansion = (hierarchyExpansion) => dispatch => {

  dispatch({
    type: SET_HEIRARCHY_EXPANSION,
    payload: hierarchyExpansion
  });

}